import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { orderBy, get } from 'lodash';
import { toast } from 'react-toastify';
import haversine from 'haversine';

import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { AutoComplete } from 'primereact/autocomplete';

import 'react-toastify/dist/ReactToastify.css';
import { displayErrors } from '../../../util/diversos';

import { fillColumns } from '../../../components/table';
import { Input155px, InputCampoBusca100px, InputCampoBusca155px } from '../../../styles/inputGroup';
import IconButton from '../../../components/IconButton';

import Card from '../../../components/card';
import Loading from '../../loading';
import axiosCoto from '../../../services/axiosCoto';

export default function ConsultaProduto() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const idVendedor = useSelector((state) => state.auth.user.id);
  const latitudeVendedor = useSelector((state) => state.auth.user.latitude);
  const longitudeVendedor = useSelector((state) => state.auth.user.longitude);

  const [km, setKm] = useState(200);
  const [listaMunicipios, setListaMunicipios] = useState([]);
  const cidadeVendedor = useSelector((state) => state.auth.user.cidade);
  const [cidade, setCidade] = useState(cidadeVendedor);
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [filteredMunicipios, setFilteredMunicipios] = useState(null);
  const [showConfirmDialogConvite, setShowConfirmDialogConvite] = useState(false);

  const [dataTableList, setDataTableList] = useState([]);
  const [selectedItens, setSelectedItens] = useState(null);
  const [findField, setFindField] = useState('');
  const [sortField, setSortField] = useState('razaoSocial');
  const [sortOrder, setSortOrder] = useState(null);

  const [dataTableColumn] = useState([
    { field: 'razaoSocial', header: 'Nome', sort: true },
    { field: 'email', header: 'E-mail', sort: true },
    { field: 'telefone1', header: 'Telefone', sort: true },
    { field: 'cidade', header: 'Cidade', sort: true },
    { field: 'ramoNegocio.descricao', header: 'Ramo', sort: true },
  ]);

  async function getMunicipioInicial() {
    try {
      setIsLoading(true);
      const municipioInicial = await axiosCoto.get(`/municipio/?descricao=${cidadeVendedor}`);
      setLatitude(municipioInicial.data[0].latitude);
      setLongitude(municipioInicial.data[0].longitude);

      const municipioDropDown = [];
      municipioDropDown.push({
        label: municipioInicial.data[0].descricao,
        value: municipioInicial.data[0].descricao,
        codigo: municipioInicial.data[0].codigo,
        uf: municipioInicial.data[0].uf,
        latitude: municipioInicial.data[0].latitude,
        longitude: municipioInicial.data[0].longitude,
      });

      setFilteredMunicipios(municipioDropDown);
    } catch (err) {
      displayErrors(err, dispatch, navigate, '/', '');
    } finally {
      setIsLoading(false);
    }
  }

  async function getData() {
    try {
      setIsLoading(true);
      const params = `/usuario/?idVendedor=${idVendedor}`;

      const response = await axiosCoto.get(params);

      const vinculos = await axiosCoto.get(`/vinculocompradorvendedor/?idVendedor=${idVendedor}`);

      const encontreVinculo = function (lista, id) {
        const existe = lista.find((value) => value.id === id);
        return existe;
      };

      const listaCompradores = [];
      for (let x = 0; x < response.data.length; x++) {
        const start = {
          latitude: latitudeVendedor,
          longitude: longitudeVendedor,
        };
        const end = {
          latitude: response.data[x].latitude,
          longitude: response.data[x].longitude,
        };

        const distanciaEmKm = haversine(start, end, { unit: 'km' });

        if (distanciaEmKm >= 0) {
          if (response.data[x].raioAtuacao >= distanciaEmKm) {
            // verifica se vinculo existe
            if (!encontreVinculo(vinculos.data.compradores, response.data[x].id)) {
              listaCompradores.push(response.data[x]);
            }
          }
        }
      }

      setDataTableList(listaCompradores);
    } catch (err) {
      displayErrors(err, dispatch, navigate, '/', '');
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getData();
    getMunicipioInicial();

    async function getMunicipios() {
      setIsLoading(true);

      try {
        const listDropdown = [];

        const { data: _municipios } = await axiosCoto.get('/municipio');

        _municipios.forEach(element => {
          listDropdown.push({
            label: element.descricao,
            value: element.descricao,
            codigo: element.codigo,
            uf: element.uf,
            latitude: element.latitude,
            longitude: element.longitude,
          });
        });

        setListaMunicipios(listDropdown);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }

    getMunicipios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const handleChangeCidade = (event) => {
    setCidade(event.value);
    setLatitude(get(event.value, 'latitude', ''));
    setLongitude(get(event.value, 'longitude', ''));
  };

  const searchMunicipios = (event) => {
    const listDropdown = [];
    listaMunicipios.forEach(element => {
      if (element.label.toLowerCase().startsWith(event.query.toLowerCase())) {
        listDropdown.push({
          label: element.label,
          value: element.value,
          codigo: element.codigo,
          uf: element.uf,
          latitude: element.latitude,
          longitude: element.longitude,
        });
      }
    });
    setFilteredMunicipios(listDropdown);
  };

  const handleFind = () => {
    const searchFilter = {
      findField,
      idVendedor,
    };

    setFindField('');
    getData(searchFilter);
  };

  async function vincularRegistro() {
    let vinculoSucesso = false;
    let emailComprador = '';
    try {
      setIsLoading(true);

      const idComprador = get(selectedItens, 'id', 0);
      emailComprador = get(selectedItens, 'email', '');
      const dataConviteVendedor = new Date().toISOString();
      const aceiteVendedor = true;
      const shippingData = {
        idVendedor,
        idComprador,
        dataConviteVendedor,
        aceiteVendedor,
      };

      if (idComprador > 0) {
        await axiosCoto.post('/vinculocompradorvendedor/', shippingData);
        toast.success('Convite enviado ao Comprador com sucesso.');
        setShowConfirmDialogConvite(false);
        getData('');
      }

      vinculoSucesso = true;
    } catch (err) {
      displayErrors(err, dispatch, navigate, '/', '');
    } finally {
      setIsLoading(false);
    }

    if (vinculoSucesso) {
      try {
        await axiosCoto.put(`/vinculocompradorvendedor/enviaremailconvite/${emailComprador}`);
      } catch (err) {
        displayErrors(err, dispatch, navigate, '/', '');
      } finally {
        setIsLoading(false);
      }
    }
  }

  const handleConvidar = (e) => {
    e.preventDefault();
    const id = get(selectedItens, 'id', 0);
    const aguardoConvite = get(selectedItens, 'convite', '');
    if (id > 0 && aguardoConvite === '') {
      setShowConfirmDialogConvite(true);
    } else {
      toast.warning('Vendedor não selecionado ou aguardando confirmação do convite.');
    }
  };

  const confirmConvite = (e) => {
    e.preventDefault();
    const idComprador = get(selectedItens, 'id', 0);
    if (idComprador > 0) {
      vincularRegistro();
    } else {
      toast.warning('Por favor, selecione o registro para convidar.');
    }
  };

  const cancelConvite = () => {
    setShowConfirmDialogConvite(false);
  };

  const confirmDialogFooterConvite = (
    <div>
      <IconButton titulo="Sim" mensagem="Sim" btnStyle="primary" onClick={confirmConvite} icon="check" />
      <IconButton titulo="Não" mensagem="Não" btnStyle="danger" onClick={cancelConvite} icon="times" />
    </div>
  );

  const handleCancel = () => {
    navigate('/consultacomprador');
  };

  const onSort = (e) => {
    setSortField(e.sortField);
    setSortOrder(e.sortOrder);

    setDataTableList(orderBy(dataTableList, [sortField], [sortOrder]));
  };

  const renderTablePrimeReact = useMemo(() => (
    <div className="datatable-compradores">
      <div className="card">
        <DataTable
          value={dataTableList}
          size="small"
          stripedRows
          sortField={sortField}
          setOrder={sortOrder}
          onSort={onSort}
          responsiveLayout="scroll"
          selectionMode="single"
          selection={selectedItens}
          onSelectionChange={e => setSelectedItens(e.value)}
          selectableRows
          dataKey="id"
          paginator
          rows={10}
          emptyMessage="Nenhum registro a ser exibido"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="{currentPage} de {totalPages}"
          rowsPerPageOptions={[10, 25, 50]}
        >
          {fillColumns(dataTableColumn)}
        </DataTable>
      </div>
    </div>
    // eslint-disable-next-line react-hooks/exhaustive-deps
  ), [dataTableList, selectedItens]);

  return (
    <>
      <Loading isLoading={isLoading} />
      <Card title="Convidar Compradores">
        <div>
          <div className="row align-items-center">
            <div className="col-7">
              <div className="p-inputgroup">
                <Input155px className="p-inputgroup-addon">
                  Buscar por:
                </Input155px>
                <InputCampoBusca100px className="p-inputgroup-addon">
                  Cidade
                </InputCampoBusca100px>
                <AutoComplete
                  autoFocus
                  value={cidade}
                  maxLength={40}
                  suggestions={filteredMunicipios}
                  completeMethod={searchMunicipios}
                  field="label"
                  dropdown
                  forceSelection
                  onChange={(e) => handleChangeCidade(e)}
                />
              </div>
            </div>
            <div className="col-3">
              <div className="p-inputgroup">
                <InputCampoBusca155px className="p-inputgroup-addon" title="Área de atendimento dos vendedores.">
                  KMs de atuacao
                </InputCampoBusca155px>
                <InputText
                  maxLength={3}
                  value={km}
                  onChange={e => setKm(e.target.value)}
                />
                <IconButton titulo="" mensagem="Buscar" btnStyle="success" onClick={handleFind} icon="search" />
              </div>
            </div>
            <div className="col-2" style={{ textAlign: 'right' }}>
              <IconButton titulo="" mensagem="Convidar Comprador" btnStyle="primary" onClick={handleConvidar} icon="plus" />
            </div>
          </div>
        </div>
        <br />

        {renderTablePrimeReact}

        <Dialog
          header="Confirmação"
          visible={showConfirmDialogConvite}
          style={{ width: '50vw' }}
          footer={confirmDialogFooterConvite}
          onHide={() => setShowConfirmDialogConvite(false)}
        >
          <p>
            Convidar comprador?
          </p>
        </Dialog>

        <div className="col-12" style={{ textAlign: 'right' }}>
          <IconButton titulo="Voltar" mensagem="Voltar" btnStyle="success" onClick={handleCancel} icon="chevron-left" />
        </div>
      </Card>
    </>
  );
}
